import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
import storage from "redux-persist/lib/storage";
import { persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
/** Reducers Import */
import CommonReducer from "../Redux-Reducer/CommonReducer";
import LocalStorageReducer from "../Redux-Reducer/LocalStorageReducer";

const reducers = combineReducers({
  common: CommonReducer,
  localStorage: LocalStorageReducer,
});

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["localStorage"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
